import { Product } from './product';

export class Brand {
  /**
   * Constructor
   * @param id Brand ID
   * @param name Name of Brand
   * @param products List of Products.
   */
  constructor(
    public id: number,
    public name: string,
    public products: Array<Product>,
  ) { }
}
